import Navbar from '../components/Navbar'
import Hero from '../components/Hero'
import Services from '../components/Services'
import Work from '../components/Work'
import Process from '../components/Process'
import About from '../components/About'
import Brief from '../components/Brief'
import Footer from '../components/Footer'

export default function Home() {
  return (
    <div className="site min-h-screen">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[60] focus:bg-vault focus:text-mariner focus:px-4 focus:py-2 focus:rounded-sm">
        Skip to content
      </a>
      <Navbar />
      <main id="main">
        <Hero />
        <Services />
        <Work />
        <Process />
        <About />
        <Brief />
      </main>
      <Footer />
    </div>
  )
}
